import { render, staticRenderFns } from "./EditorApp.vue?vue&type=template&id=27dbfc76&"
import script from "./EditorApp.vue?vue&type=script&lang=js&"
export * from "./EditorApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports